import React, { useState, useEffect } from 'react';
import {
  Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, IconButton,  Box, Container, Typography
} from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import axios from 'axios';
import AdminLayout from './Admin_Layout/AdminLayout';
import { useNavigate } from 'react-router-dom'; // Import useNavigate hook


const TestimonialsTable = () => {
  const [testimonials, setTestimonials] = useState([]);
  const navigate = useNavigate(); // Initialize the navigate hook
  useEffect(() => {
    const fetchTestimonials = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/testimonials`);
        console.log(response)
        setTestimonials(response.data);
      } catch (error) {
        console.error('Error fetching testimonials:', error);
      }
    };

    fetchTestimonials();
  }, []);

  const handleEdit = (id, testimonial) => {
    // Navigate to the edit page with the state
    navigate('/admin-dashboard/edit-testimonials/update-testimonials/specific', {
      state: {
        update: true,
        formData: testimonial
      }
    });
  };
  const handleDelete = async (id) => {
    try {
      await axios.delete(`${process.env.REACT_APP_API_URL}/api/testimonials/${id}`);
      setTestimonials(testimonials.filter(testimonial => testimonial._id !== id)); // Remove deleted testimonial from state
    } catch (error) {
      console.error('Error deleting testimonial:', error);
    }
  };

  return (
    <AdminLayout>
      <Box sx={{ p: 4 }}>
        <Container maxWidth="lg">
          <Paper elevation={3} sx={{ p: 3, borderRadius: 2 }}>
            <Typography variant="h4" gutterBottom sx={{ mt: 5 }}>
              Testimonials
            </Typography>
            <TableContainer>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell><strong>Author</strong></TableCell>
                    <TableCell><strong>Quote</strong></TableCell>
                    <TableCell><strong>School</strong></TableCell>
                    <TableCell><strong>Title</strong></TableCell>
                    <TableCell><strong>Avatar</strong></TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {testimonials.map((test, index) => (
                    <TableRow key={index}>
                      <TableCell>{test.author}</TableCell>
                      <TableCell>{test.quote}</TableCell>
                      <TableCell>{test.school}</TableCell>
                      <TableCell>{test.title}</TableCell>
                      <TableCell>
                        {test.avatar ? (
                          <img
                            src={`${test.avatar}`}
                            alt={test.image}
                            style={{ width: 100, height: 60, objectFit: 'cover', borderRadius: '4px' }}
                          />
                        ) : (
                          'No Image'
                        )}
                      </TableCell>
                      <TableCell>
                        <IconButton
                          color="primary"
                          onClick={() => handleEdit(test._id, test)}
                        >
                          <EditIcon />
                        </IconButton>
                        <IconButton
                          color="primary"
                          onClick={() => handleDelete(test._id)}
                        >
                          <DeleteIcon />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Paper>
        </Container>
      </Box>
    </AdminLayout>
  );
};

export default TestimonialsTable;
